module.exports = __webpack_public_path__ + "static/media/NewDesignHrUploading.5e3dd4d1.svg";